import { createClient, type SupabaseClient } from "@supabase/supabase-js";

let client: SupabaseClient | null = null;

export function createSupabaseClient(): SupabaseClient {
  if (client) {
    return client;
  }
  const url = import.meta.env.VITE_SUPABASE_URL;
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
  if (!url || !anonKey) {
    throw new Error("Thiếu cấu hình Supabase");
  }
  client = createClient(url, anonKey);
  return client;
}

/** Test seam: replace the memoized client (never used in production code paths). */
export function setSupabaseClientForTests(value: SupabaseClient | null): void {
  client = value;
}
